import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { handleInvalidToken } from "../../AuthUtils";
import AnimationSpinner from "../../AnimationSpinner";
import GetToken from "../../GetToken";
import UpGradeBox from "../../components/upgradeBox/UpGradeBox";
import Premium from "../../assets/images/oto/premium.png"
import Max from "../../assets/images/oto/max.png"
import dfy from "../../assets/images/oto/dfy.png"
import fe from "../../assets/images/oto/live.png"
import Store from "../../assets/images/oto/store.png"
import Agency from "../../assets/images/oto/agency.png"
import Reseller from "../../assets/images/oto/reseller.png"
import Whitelabel from "../../assets/images/oto/whitelabel.png"
import Worker from "../../assets/images/oto/worker.png"
import Appointment from "../../assets/images/oto/appointment.png"
import Suite from "../../assets/images/oto/suite.png"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


const UpGradePage = ({ base_url }) => {
	const [userPackages, setUserPackages] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchUserPackage = async () => {
			try {
				const token = GetToken();
				if (!token) {
					handleInvalidToken();
					return;
				}
				setLoading(true);
				const formdata = new FormData();
				formdata.append("action", "fetchUserPackages");
				formdata.append("token", token);
				const response = await axios.post(
					`${base_url}api/user/get-user-resource`,
					formdata
				);
				if (response.data.status) {
					setLoading(false);
					// console.log(response.data)
					setUserPackages(response.data.items);
				} else {
					setLoading(false);
					if (response.data.reset) {
						handleInvalidToken(navigate);
						return;
					}
					toast.error(response.data.message);
					// Swal.fire({
					// 	icon: "error",
					// 	title: "Error",
					// 	text: response.data.message,
					// });
				}
			} catch (error) {
				setLoading(false);
				toast.error(error.response?.data?.message ||
					error.message ||
					"Failed to insert data. Please try again.");
				// Swal.fire({
				// 	icon: "error",
				// 	title: "Error",
				// 	text:
				// 		error.response?.data?.message ||
				// 		error.message ||
				// 		"Failed to insert data. Please try again.",
				// });
			}
		};
		fetchUserPackage();
	}, []);

	return (
		<div className="right-container">
			<AnimationSpinner show={loading} />
			<div className="content">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="page-title-box">
								<h4 className="page-title">Upgrade</h4>
							</div>
						</div>
					</div>
				<div className="row">
					{(userPackages.includes(1) && !userPackages.includes(2) && !userPackages.includes(34)) || userPackages.includes(33) ? (
						<UpGradeBox title={"BookFlow AI Frontend"} activated={true} img={fe} />
					) : (userPackages.includes(2) || userPackages.includes(34)) || (userPackages.includes(1) && userPackages.includes(2)) ? (
						<UpGradeBox title={"BookFlow AI Business Edition"} activated={true} img={fe} />
					) : <UpGradeBox title={"BookFlow AI Frontend "} activated={false} img={fe} upgrade={"Frontend"} url="" />}

					{userPackages.includes(3) || userPackages.includes(35) ? (
						<UpGradeBox title={"BookFlow AI Premium Edition"} activated={true} img={Premium} />
					) : <UpGradeBox title={"BookFlow AI Premium Edition"} activated={false} img={Premium} upgrade={"Premium"} url="https://getbookflowai.com/oto1" />}

					{userPackages.includes(4) || userPackages.includes(36) ? (
						<UpGradeBox title={"BookFlow AI Max Edition"} activated={true} img={Max} />
					) : <UpGradeBox title={"BookFlow AI Max Edition"} activated={false} img={Max} upgrade={"Max"} url="https://getbookflowai.com/oto2" />}

					{userPackages.includes(5) || userPackages.includes(37) ? (
						<UpGradeBox title={"BookFlow AI Suite Edition"} activated={true} img={Suite} />
					) : <UpGradeBox title={"BookFlow AI Suite Edition"} activated={false} img={Suite} upgrade={"Worker"} url="https://getbookflowai.com/oto3" />}


					{userPackages.includes(6) || userPackages.includes(38) ? (
						<UpGradeBox title={"BookFlow AI Worker Edition"} activated={true} img={Worker} />
					) : <UpGradeBox title={"BookFlow AI Worker Edition"} activated={false} img={Worker} upgrade={"Worker"} url="https://getbookflowai.com/oto4" />}


					{userPackages.includes(7) || userPackages.includes(39) ? (
						<UpGradeBox title={"BookFlow AI DFY Edition"} activated={true} img={dfy} />
					) : <UpGradeBox title={"BookFlow AI DFY Edition"} activated={false} img={dfy} upgrade={"DFY"} url="https://getbookflowai.com/oto5" />}


					{userPackages.includes(8) || userPackages.includes(40) ? (
						<UpGradeBox title={"BookFlow AI Store Edition"} activated={true} img={Store} />
					) : <UpGradeBox title={"BookFlow AI Store Edition"} activated={false} img={Store} upgrade={"Store"} url="https://getbookflowai.com/oto6" />}

					{userPackages.includes(9) || userPackages.includes(41) ? (
						<UpGradeBox title={"BookFlow AI Appointment Edition"} activated={true} img={Appointment} />
					) : <UpGradeBox title={"BookFlow AI Appointment Edition"} activated={false} img={Appointment} upgrade={"Appointment"} url="https://getbookflowai.com/oto7" />}

					{userPackages.includes(10) || userPackages.includes(11) || userPackages.includes(42) ? (
						<UpGradeBox title={"BookFlow AI Agency Edition"} activated={true} img={Agency} />
					) : <UpGradeBox title={"BookFlow AI Agency Edition"} activated={false} img={Agency} upgrade={"Agency"} url="https://getbookflowai.com/oto8" />}

					{userPackages.includes(12) || userPackages.includes(13) || userPackages.includes(43) ? (
						<UpGradeBox title={"BookFlow AI Reseller Edition"} activated={true} img={Reseller} />
					) : <UpGradeBox title={"BookFlow AI Reseller Edition"} activated={false} img={Reseller} upgrade={"Reseller"} url="https://getbookflowai.com/oto9" />}

					{userPackages.includes(14) || userPackages.includes(44) ? (
						<UpGradeBox title={"BookFlow AI Whitelabel Edition"} activated={true} img={Whitelabel} />
					) : <UpGradeBox title={"BookFlow AI Whitelabel Edition"} activated={false} img={Whitelabel} upgrade={"Whitelabel"} url="https://getbookflowai.com/oto10" />}

					{userPackages.includes(15) || userPackages.includes(45) ? (
						<UpGradeBox title={"BookFlow AI VIP Pack"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(16) || userPackages.includes(46) ? (
						<UpGradeBox title={"BookFlow AI Automation Pack"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(17) || userPackages.includes(47) ? (
						<UpGradeBox title={"BookFlow AI Unlimited Pack"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(18) || userPackages.includes(48) ? (
						<UpGradeBox title={"BookFlow AI Suite VIP Pack"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(19) || userPackages.includes(49) ? (
						<UpGradeBox title={"BookFlow AI Ultimate Pack"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(20) || userPackages.includes(50) ? (
						<UpGradeBox title={"BookFlow AI DFY Club"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(21) || userPackages.includes(51) ? (
						<UpGradeBox title={"BookFlow AI Store Unlimited Access"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(22) || userPackages.includes(52) ? (
						<UpGradeBox title={"BookFlow AI Appointment Unlimited Access"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(23) || userPackages.includes(53) ? (
						<UpGradeBox title={"BookFlow AI Agency Club"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(24) || userPackages.includes(54) ? (
						<UpGradeBox title={"BookFlow AI Reseller Bundle"} img={fe} activated={true} />
					) : null}
					{userPackages.includes(25) || userPackages.includes(55) ? (
						<UpGradeBox title={"BookFlow AI Developer VIP Pack"} img={fe} activated={true} />
					) : null}
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpGradePage;
